import styles from "./Stepper.module.css";

interface Props {
  value: number;
  name?: string;
  disabled?: boolean;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

export default function Stepper({
  value,
  name,
  disabled,
  onChange,
  min = 0,
  max = Infinity,
}: Props) {
  return (
    <span className={styles.Stepper} aria-disabled={disabled}>
      <button
        type="button"
        disabled={disabled || value <= min}
        onClick={() => onChange(value - 1)}
      >
        -
      </button>

      <input
        name={name}
        type="text"
        readOnly
        value={value}
        className={styles.StepperViewer}
      />

      <button
        type="button"
        disabled={disabled || value >= max}
        onClick={() => onChange(value + 1)}
      >
        +
      </button>
    </span>
  );
}
